// extracted by mini-css-extract-plugin
export default {"container":"SegmentsHeader_container__3Rilo","title":"SegmentsHeader_title__YCyuK","subtitle":"SegmentsHeader_subtitle__M2+xP"};